import styled from "styled-components";
import colors from "@styling/colors";
import { borderRadius, spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";

const StyledListButton = styled.button<{ $isSelected: boolean; $compact?: boolean }>`
  width: 100%;
  padding: ${({ $compact }) =>
    $compact ? `${spacing.x1}px ${spacing.x2}px` : `${spacing.x2}px ${spacing.x3}px`};
  text-align: left;
  border: 1px solid ${({ $isSelected }) => ($isSelected ? colors.primary : colors.border)};
  border-radius: ${borderRadius.regular}px;
  background-color: ${({ $isSelected }) => ($isSelected ? colors.primary : colors.backgroundLight)};
  color: ${({ $isSelected }) => ($isSelected ? colors.primaryContrastText : colors.text)};
  font-size: ${({ $compact }) => ($compact ? fontSizes.small : fontSizes.regular)}px;
  font-weight: ${({ $isSelected }) => ($isSelected ? 600 : 400)};
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    border-color: ${colors.primary};
    background-color: ${({ $isSelected }) => ($isSelected ? colors.primary : colors.background)};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

type ListButtonProps = {
  isSelected?: boolean;
  compact?: boolean;
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
};

export const ListButton = ({
  isSelected = false,
  compact = false,
  onClick,
  disabled = false,
  children,
}: ListButtonProps) => {
  return (
    <StyledListButton
      $isSelected={isSelected}
      $compact={compact}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </StyledListButton>
  );
};

